<template>
  <LogoView :size="size" :img-url="img" alt="Clear Estate Logo" />
</template>

<script>
import img from '/@/assets/logos/logo.svg';
import LogoView from '@/modules/core/app/components/LogoView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClearEstateLogo',
  components: { LogoView },
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (prop) =>
        ['tiny', 'small', 'medium', 'extra-medium', 'medium-large', 'large', 'full'].includes(prop)
    }
  },
  static: {
    img
  }
};
</script>
